import { datadogRum, RumInitConfiguration } from "@datadog/browser-rum";

export enum RumApp {
  M3 = "M3",
  CONSUMER_APP = "CONSUMER_APP",
  DASHBOARD = "DASHBOARD",
  PERSON_REGISTRATION = "PERSON_REGISTRATION",
  LOGIN = "LOGIN",
  ADMIN_CONSOLE = "ADMIN_CONSOLE",
}

export function initializeRum(app: RumApp): RumInitConfiguration | null {
  // RUM runs only on prod.
  if (process.env.VUE_APP_APP_URL !== "https://app.payjoy.com") {
    return null;
  }

  const rumSettings: Partial<Record<RumApp, RumInitConfiguration>> = {
    [RumApp.M3]: {
      applicationId: process.env.VUE_APP_DATADOG_RUM_MERCHANT3_APP_ID ?? "",
      clientToken: process.env.VUE_APP_DATADOG_RUM_MERCHANT3_CLIENT_TOKEN ?? "",
      site: "datadoghq.com", // Use 'datadoghq.eu' if you're in the EU region
      service: "m3", // Name of your service
      version: "1.0.0", // Version of your application
      env: process.env.NODE_ENV ?? "development", // Environment (e.g., development, production)
      sessionSampleRate: 10, // Percentage of sessions to record (0-100). This is the sample rate for RUM itself. See https://docs.google.com/document/d/1rOEwGet3iYj63zKoXiQkQIAwS6c3tijYSNHK9bNyJBI/edit?usp=sharing
      sessionReplaySampleRate: 0, // Percentage of sessions to replay (0-100). Of the sessions that are sampled above, this is the percentage of sessions for which a video record of the session is created.
      trackUserInteractions: true, // Enable tracking of user interactions
      defaultPrivacyLevel: "mask-user-input", // Mask sensitive data by default
    },
    [RumApp.CONSUMER_APP]: {
      applicationId: process.env.VUE_APP_DATADOG_RUM_CONSUMER_APP_ID ?? "",
      clientToken: process.env.VUE_APP_DATADOG_RUM_CONSUMER_CLIENT_TOKEN ?? "",
      site: "datadoghq.com",
      service: "consumer-app-frontend",
      env: process.env.NODE_ENV ?? "development",
      sessionSampleRate: 10, // See comment in M3 section
      sessionReplaySampleRate: 0, // See comment in M3 section
      defaultPrivacyLevel: "mask-user-input",
    },
  };

  const settings = rumSettings[app] ?? null;

  if (!settings) {
    return null;
  }

  datadogRum.init(settings);
  return settings; // Return settings for testing purposes
}
